import FeaturesContainer from './FeaturesContainer'

const LocationHistory = ({ history }) => {
    return <FeaturesContainer history={history} pageName={'location-history'} nextUrl={'panic-button'} pageEvent={'onboardingLocationHistory'} clickEvent={'onboardingLocationHistorySubmitted'} />
};

export default LocationHistory